import { render, staticRenderFns } from "./UpsiSummaryList.vue?vue&type=template&id=3d006c21"
import script from "./UpsiSummaryList.vue?vue&type=script&lang=js"
export * from "./UpsiSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports